/* eslint-disable react/no-unescaped-entities */
import React from "react";

import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Wrapper, Title, DescriptionContainer, Description } from "./styles";

const defaultIcon = require("Assets/img/empty-estimated-quote.svg");

type ShipmentOrderEmptySectionProps = {
  icon?: string;
};

export const ShipmentOrderEmptySection: React.FC<ShipmentOrderEmptySectionProps> = (props) => {
  const { icon } = props;

  const { t: translate } = useTranslation();

  return (
    <Wrapper
      container
      direction="column"
      alignItems="center"
      justifyContent="center"
      data-cy="despatch-maintenance-empty"
    >
      <Grid item xs={12}>
        <img src={icon || defaultIcon} alt="empty state" />
      </Grid>
      <Grid
        container
        item
        spacing={2}
        direction="column"
        alignItems="center"
        justifyContent="center"
      >
        <Grid item xs={4}>
          <Title>{translate("itLooksLikeThereSNoDataYet")}</Title>
        </Grid>
        <DescriptionContainer item xs={4}>
          <Description>{translate("youCanStartByAddingAnOrder")}</Description>
        </DescriptionContainer>
      </Grid>
    </Wrapper>
  );
};
